import BaseService from "./geral/BaseService";

const base = "DirecionamentoRecinto";

export default class DirecionamentoRecintoService extends BaseService {
    constructor() {
        super(base);
    }

    
    Operacoes(dataInicial, dataFinal, tipoDoc) {
        return super.httpGet(`/${base}/Operacoes?dataInicial=${dataInicial}&dataFinal=${dataFinal}&tipoDocumento=${tipoDoc}`);
        
    }

    Status() {
        return super.httpGet(`/${base}/ListaStatus`)
    }
    
    //Recinto
    RecintoConsultar(direcionamentoRaId="", direcionamentoRaCeId="", operacao="", status="", ceHouse="", container="", cnpj="", cliente="") {
        //return super.httpGet(`/${base}/ConsultaDirecionamentoRecinto?direcionamentoRaId=&direcionamentoRaCeId=&operacao=BD1045N&status=&ceHouse=101805257710738&container=&cnpj=&cliente=`);
        //Demora demais isso daqui
        return super.httpGet(`/${base}/ConsultaDirecionamentoRecinto?&direcionamentoRaId=${direcionamentoRaId}&direcionamentoRaCeId=${direcionamentoRaCeId}&operacao=${operacao}&status=${status}&ceHouse=${ceHouse}&container=${container}&cnpj=${cnpj}&cliente=${cliente}`);
    }
    RecintoCarregarOutrosDados(ceRaId="") {
        return super.httpGet(`/${base}/CarregaRecinto/${ceRaId}`)
    }
    RecintoDownloadDocumento(ceRaId="") {
        return super.httpGet(`/${base}/DownloadDocumentoRecinto/${ceRaId}`)
    }
    RecintoInativar(inativados=[]) {
        return super.httpPost(`/${base}/InativaRecinto/`,inativados)
    }
    RecintoInclusao(tipoDoc="", flagCarga="",ceHouse="", container="", cnpj="", razaoSocial, operacao="", arq="") {
        return super.httpPost(`/${base}/InclusaoRecinto?tipoDocumento=${tipoDoc}&cargaConsolidada=${flagCarga}&ceHouse=${ceHouse}&container=${container}&cnpj=${cnpj}&razaoSocial=${razaoSocial}&operacao=${operacao}`,arq)
    }
    RecintoEditar(obj) {
        return super.httpPost(`/${base}/EditaRecinto`, obj)
    }
    RecintoImportarXls(arquivoXls) {
        return super.httpPost(`/${base}/TransformarXlsEmRecinto`,arquivoXls)
    }
    RecintoOperacoes() {
        return super.httpGet(`/${base}/OperacoesRa`)
    }

}


// WEBPACK FOOTER //
// ./src/services/DirecionamentoRecintoService.js